var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreeform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "#F8FAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3460_218197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.305 18.8477C53.1255 18.8477 52.1694 19.781 52.1694 20.9324V21.6273H56.4406V20.9324C56.4406 19.781 55.4846 18.8477 54.305 18.8477Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4406 33.4409H52.1694V54.2884H56.4406V33.4409Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1694 54.2881H56.4406L54.305 58.4576L52.1694 54.2881Z",
    fill: "#E2E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3221 21.6274H18V59.1529H49.3221V21.6274Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 54.2883V59.1527H49.3221V37.4019C42.5515 47.9152 30.721 54.2931 18 54.2883Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9152 18.8477H24.4067V21.6273H42.9152V18.8477Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2033 26.4919H35.0847C34.6917 26.4919 34.3728 26.1805 34.3728 25.7969C34.3728 25.4134 34.0539 25.102 33.6609 25.102C33.268 25.102 32.9491 25.4134 32.9491 25.7969C32.9491 26.1805 32.6301 26.4919 32.2372 26.4919H25.1186C24.7257 26.4919 24.4067 26.1805 24.4067 25.7969V21.6274H25.8305V25.102H31.6471C32.0394 24.0166 33.2596 23.4467 34.3715 23.8297C34.9808 24.0396 35.46 24.5072 35.6749 25.102H41.4915V21.6274H42.9153V25.7969C42.9152 26.1805 42.5963 26.4919 42.2033 26.4919Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4066 32.7462C25.5861 32.7462 26.5422 31.8128 26.5422 30.6614C26.5422 29.51 25.5861 28.5767 24.4066 28.5767C23.2271 28.5767 22.271 29.51 22.271 30.6614C22.271 31.8128 23.2271 32.7462 24.4066 32.7462Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4066 39.6949C25.5861 39.6949 26.5422 38.7615 26.5422 37.6101C26.5422 36.4588 25.5861 35.5254 24.4066 35.5254C23.2271 35.5254 22.271 36.4588 22.271 37.6101C22.271 38.7615 23.2271 39.6949 24.4066 39.6949Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0506 29.9665H35.0844C34.6915 29.9665 34.3726 29.6552 34.3726 29.2716C34.3726 28.888 34.6915 28.5767 35.0844 28.5767H45.0506C45.4435 28.5767 45.7624 28.888 45.7624 29.2716C45.7624 29.6552 45.4435 29.9665 45.0506 29.9665Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2371 29.9665H29.3896C28.9967 29.9665 28.6777 29.6552 28.6777 29.2716C28.6777 28.888 28.9967 28.5767 29.3896 28.5767H32.2371C32.63 28.5767 32.9489 28.888 32.9489 29.2716C32.9489 29.6552 32.6301 29.9665 32.2371 29.9665Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0508 32.7463H39.3559C38.963 32.7463 38.644 32.4349 38.644 32.0514C38.644 31.6678 38.963 31.3564 39.3559 31.3564H45.0508C45.4438 31.3564 45.7627 31.6678 45.7627 32.0514C45.7627 32.4349 45.4438 32.7463 45.0508 32.7463Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5083 32.7463H29.3896C28.9967 32.7463 28.6777 32.4349 28.6777 32.0514C28.6777 31.6678 28.9967 31.3564 29.3896 31.3564H36.5083C36.9012 31.3564 37.2201 31.6678 37.2201 32.0514C37.2201 32.4349 36.9012 32.7463 36.5083 32.7463Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0505 36.9157H42.2031C41.8101 36.9157 41.4912 36.6044 41.4912 36.2208C41.4912 35.8372 41.8101 35.5259 42.2031 35.5259H45.0505C45.4435 35.5259 45.7624 35.8372 45.7624 36.2208C45.7624 36.6044 45.4435 36.9157 45.0505 36.9157Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3557 36.9157H29.3896C28.9967 36.9157 28.6777 36.6044 28.6777 36.2208C28.6777 35.8372 28.9967 35.5259 29.3896 35.5259H39.3557C39.7487 35.5259 40.0676 35.8372 40.0676 36.2208C40.0676 36.6044 39.7487 36.9157 39.3557 36.9157Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0507 39.6955H37.2202C36.8272 39.6955 36.5083 39.3842 36.5083 39.0006C36.5083 38.617 36.8272 38.3057 37.2202 38.3057H45.0507C45.4436 38.3057 45.7626 38.617 45.7626 39.0006C45.7626 39.3842 45.4436 39.6955 45.0507 39.6955Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3727 39.6955H29.3896C28.9967 39.6955 28.6777 39.3842 28.6777 39.0006C28.6777 38.617 28.9967 38.3057 29.3896 38.3057H34.3727C34.7656 38.3057 35.0845 38.617 35.0845 39.0006C35.0845 39.3842 34.7656 39.6955 34.3727 39.6955Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2883 32.0511C58.8954 32.0511 58.5765 31.7398 58.5765 31.3562V25.102C58.5765 23.9506 57.6204 23.0173 56.4409 23.0173C56.0479 23.0173 55.729 22.7059 55.729 22.3224C55.729 21.9388 56.0479 21.6274 56.4409 21.6274C58.4056 21.6295 59.9981 23.1841 60.0002 25.102V31.3563C60.0002 31.7399 59.6813 32.0511 59.2883 32.0511Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4406 21.6274H52.1694V33.441H56.4406V21.6274Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9154 56.3731C44.0948 56.3731 45.051 55.4397 45.051 54.2884C45.051 53.137 44.0948 52.2036 42.9154 52.2036C41.7359 52.2036 40.7798 53.137 40.7798 54.2884C40.7798 55.4397 41.7359 56.3731 42.9154 56.3731Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0502 54.6684C35.612 53.3522 36.509 51.4377 36.5083 49.4238H28.6777L34.0502 54.6684Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6778 49.424H36.5084C36.5169 45.5777 33.3299 42.4527 29.3897 42.4444C25.4495 42.436 22.2483 45.5471 22.2398 49.3935C22.2312 53.2399 25.4182 56.3649 29.3584 56.3732C31.0818 56.3767 32.7483 55.7714 34.0503 54.6686L28.6778 49.424Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9154 46.6446C44.0948 46.6446 45.051 45.7112 45.051 44.5599C45.051 43.4085 44.0948 42.4751 42.9154 42.4751C41.7359 42.4751 40.7798 43.4085 40.7798 44.5599C40.7798 45.7112 41.7359 46.6446 42.9154 46.6446Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0506 54.6686C35.6067 53.3566 36.503 51.4498 36.5087 49.4429C34.8159 50.3998 33.0483 51.2232 31.2217 51.9063L34.0506 54.6686Z",
    fill: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8848 53.8291C26.3699 56.7943 30.8468 57.2314 33.8843 54.8055C33.9406 54.761 33.996 54.7152 34.0502 54.6685L31.2205 51.9062C28.85 52.7923 26.3912 53.4372 23.8848 53.8291Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4756 46.0883C42.3341 46.8701 43.6803 46.8242 44.481 45.9861C45.1993 45.2342 45.2456 44.082 44.5892 43.2773C43.6069 44.2718 42.5676 45.21 41.4756 46.0883Z",
    fill: "#64748B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4409 54.2885V51.5088C56.4416 52.5032 56.1283 53.474 55.5439 54.2885H56.4409Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0947 56.0983L54.3049 58.4576L56.4405 54.2881H55.5436C54.942 55.1275 54.0856 55.7614 53.0947 56.0983Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5933 57.7628C53.5933 58.1464 53.9122 58.4577 54.3051 58.4577C54.6981 58.4577 55.017 58.1464 55.017 57.7628V57.0679H53.5933V57.7628Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4309 21.6273H56.4408V20.9324C56.4437 19.7837 55.4919 18.8505 54.3152 18.8477C53.8696 18.8469 53.4346 18.9818 53.0723 19.2348C54.4106 19.6885 55.5801 20.5211 56.4309 21.6273Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.644 54.983H36.5084C36.3198 54.983 36.1382 54.9101 36.0052 54.7794L33.1577 51.9997L34.1643 51.0171L36.8032 53.5931H38.644V54.983Z",
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1643 47.8307L33.1577 46.8481L36.0052 44.0684C36.1383 43.9378 36.3199 43.8647 36.5084 43.8647H38.644V45.2546H36.8032L34.1643 47.8307Z",
    fill: "#64748B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3460_218197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    fill: "white",
    transform: "translate(18 18.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeform);
export default __webpack_public_path__ + "static/media/Freeform.b25da31c996412ee7d36ec3721237e8a.svg";
export { ForwardRef as ReactComponent };